import _ from 'underscore';
import Radio from 'backbone.radio';
import AppLayout from '@/views/app_layout';
import DevicesLayout from '@/views/devices_layout_new';


    export default function() {
        var globalCh = Radio.channel('global');

        var app_layout = new AppLayout({ el: '#app-container' });
        globalCh.reply('set_app_layout', function set_app_layout(layout){
            app_layout = layout;
            return app_layout;
        });

        globalCh.reply('app_layout', function get_app_layout(){
            return app_layout;
        });

        // hashing functions for memoize
        function v5_model_hashfunc(model) {
            return [model.type, model.id].join(':');
        }
        function purge_cache(memoized_func, key) {
            delete memoized_func.cache[key];
        }
        // Memoized get_devices_layout
        var m_get_devices_layout;
        function get_devices_layout(product) {
            var layout = new DevicesLayout({ model: product });
            var purge = _.partial(purge_cache, m_get_devices_layout, v5_model_hashfunc(product));
            layout.once('destroy', purge);
            return layout;
        }
        m_get_devices_layout = _.memoize(get_devices_layout, v5_model_hashfunc);
        globalCh.reply('devices_layout_new', m_get_devices_layout);
    }

